module.exports = __webpack_public_path__ + "static/media/rima.ee49b0c3.jpeg";